export default "__VITE_ASSET__DuV6iNZl__"